/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Link_Target_Navigation_IframeInputs */

const en_enum_link_target_navigation_iframe = /** @type {(inputs: Enum_Link_Target_Navigation_IframeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation Iframe`)
};

const de_enum_link_target_navigation_iframe = /** @type {(inputs: Enum_Link_Target_Navigation_IframeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation Iframe`)
};

/**
* | output |
* | --- |
* | "Navigation Iframe" |
*
* @param {Enum_Link_Target_Navigation_IframeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_link_target_navigation_iframe = /** @type {((inputs?: Enum_Link_Target_Navigation_IframeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Link_Target_Navigation_IframeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_link_target_navigation_iframe(inputs)
	return de_enum_link_target_navigation_iframe(inputs)
});